/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable sonarjs/jsx-no-useless-fragment */
/* eslint-disable no-underscore-dangle */
import React, { useCallback, useMemo, useState } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { InputField, Select } from '@salt/components';
import { capitalize } from '../../utils/textFormat';

import caretIcon from '../../media/icons/down-arrow.svg';
import broadcastIcon from '../../media/icons/broadcast.svg';

const ProjectAccordian = ({ project, panToUserLocation, setProjectBroadcast }) => {
  const [openMembers, setOpenMembers] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpenMembers(!openMembers)}
        key={project._id}
        className={cx('w-full flex text-left hover:bg-[#F4F5F7]', {
          'border-b border-[#B4B9C1] border-solid': !openMembers,
        })}
      >
        <div className="px-6 py-4 w-full">
          <div className="flex align-top">
            <h4
              style={{ fontSize: '18px' }}
              className="font-medium truncate max-w-[350px] overflow-hidden text-ellipsis"
            >
              {capitalize(project.name)}
            </h4>
            <button
              className="ml-auto my-auto flex-shrink-0"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setProjectBroadcast({
                  name: project.name,
                  id: project.id,
                });
              }}
            >
              <img className="w-8" src={broadcastIcon} alt="" />
            </button>
            <img
              className={cx('my-auto w-4 mr-2 ml-4', {
                'rotate-180': openMembers,
              })}
              src={caretIcon}
              alt=""
            />
          </div>
        </div>
      </button>
      {openMembers &&
        project.members?.map((m) => (
          <button
            key={m.id}
            type="button"
            onClick={() => panToUserLocation(m)}
            className="w-full flex text-left hover:bg-[#F4F5F7]"
          >
            <div className="p-4 w-full">
              <div className="flex align-top pl-5">
                <h4
                  style={{ fontSize: '14px' }}
                  className="font-base truncate max-w-[350px] overflow-hidden text-ellipsis"
                >
                  {capitalize(m.user.name)}
                </h4>
              </div>
            </div>
          </button>
        ))}
    </>
  );
};

const ProjectsList = ({
  projects,
  mapRef,
  setProjectBroadcast,
  users,
  setSelectedUserId,
  filterValue,
  filteredCategories,
  setFilterValue,
  setFilteredCategories,
}) => {
  const { t } = useTranslation();

  const onFilter = useCallback(
    (event) => {
      event.preventDefault();
      setFilterValue(event.target.value);
    },
    [projects]
  );

  const projectList = useMemo(() => projects.map((p) => ({ id: p.id, name: p.name })), [projects]);

  const handleCategoryChange = useCallback(
    (newVal) => {
      let tmpVal = (filteredCategories?.length > 0 && filteredCategories?.split(',')) || [];
      if (tmpVal.includes(newVal)) {
        tmpVal = tmpVal.filter((v) => v !== newVal);
      } else {
        tmpVal.push(newVal);
      }
      setFilteredCategories(tmpVal.join(','));
    },
    [projectList, filteredCategories]
  );

  const customRenderValue = useCallback((val) => {
    const selectedItemCount = val?.split(',')?.length || 0;
    return `${selectedItemCount} ${selectedItemCount > 1 ? 'Projects' : 'Project'}`;
  }, []);

  const panToUserLocation = useCallback(
    (member) => {
      if (!mapRef) return;
      setSelectedUserId();
      if (member?.latitude && member?.longitude) {
        if (mapRef.getZoom() < 15) mapRef.setZoom(15);
        setTimeout(() => mapRef.setCenter({ lat: member.latitude, lng: member.longitude }), 100);
      }
    },
    [mapRef, users]
  );

  const filteredProjects = useMemo(
    () =>
      projects.filter(
        (project) =>
          (filterValue.trim().length === 0 ||
            project.name?.toLowerCase().includes(filterValue?.toLowerCase()) ||
            project.members?.find((m) =>
              m.user.name.toLowerCase().includes(filterValue?.toLowerCase())
            )) &&
          (filteredCategories.length === 0 || filteredCategories.includes(String(project.id)))
      ),
    [projects, filterValue, filteredCategories]
  );

  // useEffect(() => {
  //   setFilteredProjects(filteredProjects);
  // }, [filteredProjects]);

  return (
    <div>
      <div className="w-full mt-4 p-4">
        <InputField
          icon="search"
          iconPlacement="left"
          onChange={onFilter}
          onClear={() => setFilterValue('')}
          placeholder="Search by Project or User"
          value={filterValue}
          labelBackgroundClass="peer-focus:bg-secondary-light peer-[:not(:placeholder-shown)]:bg-secondary-light"
          backgroundClass="bg-secondary-light"
        />
      </div>
      <div className="w-full px-4 mb-4">
        <Select
          icon="categories"
          onClick={handleCategoryChange}
          width="w-full"
          labelBackgroundClass={`group-focus:bg-secondary-light ${filteredCategories?.length > 0 ? 'bg-secondary-light' : ''}`}
          backgroundClass="bg-secondary-light"
          multiSelect
          placeholder="Projects"
          renderItems={projectList.map((p) => ({
            id: String(p.id),
            value: p.name,
            render: () => {},
          }))}
          value={filteredCategories}
          customRenderValue={customRenderValue}
        />
      </div>
      {/* <div className="search">
        <div className="category-icon" />
        <FormControl>
          <InputLabel id="project" className="select-label text-lg!">
            {t('projects.heading')}
          </InputLabel>
          <Select
            className="select"
            labelId="category"
            id="demo-simple-select"
            value={filteredCategories}
            onChange={handleCategoryChange}
            multiple
            renderValue={(selected) => (
              <span className="select-label">
                {`${selected.length} Project${selected.length > 1 ? 's' : ''}`}
              </span>
            )}
            label="Category"
          >
            {projectsNames.map((cat) => (
              <MenuItem key={cat} value={cat}>
                <ListItemText
                  className="pl-2"
                  primary={capitalize(cat)}
                  primaryTypographyProps={{ fontSize: '1.5rem' }}
                />
                <Checkbox checked={filteredCategories.includes(cat)} size="large" />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div> */}
      {filteredProjects?.length > 0 ? (
        <div className="h-[582px] overflow-y-scroll">
          <h2 className="px-6 py-4 w-full">{t('projects.heading')}</h2>
          {filteredProjects.map((project) => (
            <ProjectAccordian
              project={project}
              key={project.id}
              panToUserLocation={panToUserLocation}
              setProjectBroadcast={setProjectBroadcast}
            />
          ))}
        </div>
      ) : (
        <div className="h-[137px] w-full flex items-center justify-center text-lg text-primary">
          {t('projects.no_projects')}
        </div>
      )}
    </div>
  );
};

export default ProjectsList;
